import styled, { css } from 'styled-components';
import { TextBlockWrapperProps } from '../types/FeatureArticle.types';

export const FeatureArticleWrapper = styled.div`
  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    a {
      text-decoration: none !important;
      position: relative;
      height: 400px;
      max-height: 400px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      @media only screen and (max-width: 794px) {
        flex-direction: column-reverse;
        justify-content: flex-end;
        height: auto;
      }
      @media only screen and (max-width: 639px) {
        max-height: initial;
      }
    }
  }
`;

export const TextBlockWrapper = styled.div<TextBlockWrapperProps>`
  text-align: start;
  padding: 20px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  width: calc(100% / 3);
  min-width: 390px;

  .chevronIcon {
    transform: scaleX(${props => props.direction === 'rtl' ? '-1' : '1'});
    color: var(--red);
    top: 0.22em;
    position: relative;
  }

  @media only screen and (max-width: 794px) {
    padding: 20px;
    width: 100%;
    min-width: 0;
  }
  > p {
    margin: 10px 0 0 0;
  }
`;

export const TagsBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  flex-wrap: wrap;
  font-size: 0.9rem;
  span {
    display: inline-block;
    margin: 0 8px;
    color: #646464;
  }
  p {
    display: inline-block;
    margin: 0;
  }
`;

export const imageBlock = css`
  object-fit: cover;
  object-position: 50% 50%;
  width: calc(100% / 3 * 2);
  height: 100%;
  @media only screen and (max-width: 794px) {
    height: 200px;
    width: 100%;
  }
`;

export const focalPointImageStyle = css`
  width: calc(100% / 3 * 2);
  height: 100%;
  @media only screen and (max-width: 794px) {
    height: 200px;
    width: 100%;
  }
`;

export const bgWhite = css`
  background: var(--white);
`;

export const bgAbbey = css`
  background: var(--gallery);
`;